export const structure = {
  map: {},
  fields: {},
  listSource: null,
  cardId: null,
  isCreate: false
}

export const nonClearableFields = ['map']
